// src/services/userService.js
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BASE_URL}/auth`;

const getToken = () => {
  return localStorage.getItem("token");
};

export const getUsers = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${API_URL}/users`, {
      headers: {
        "x-auth-token": token
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar usuários:", error);
    throw error;
  }
};

export const createUser = async newUser => {
  const token = getToken();
  try {
    const response = await axios.post(`${API_URL}/register`, newUser, {
      headers: {
        "x-auth-token": token
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar usuário:", error);
    throw error;
  }
};

export const updateUser = async (id, updatedUser) => {
  const token = getToken();
  try {
    const response = await axios.put(`${API_URL}/user/${id}`, updatedUser, {
      headers: {
        "x-auth-token": token
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar usuário:", error);
    throw error;
  }
};

export const deleteUser = async id => {
  const token = getToken();
  try {
    await axios.delete(`${API_URL}/user/${id}`, {
      headers: {
        "x-auth-token": token
      }
    });
  } catch (error) {
    console.error("Erro ao deletar usuário:", error);
    throw error;
  }
};
